import type { VariantId } from '@atlassian/edition-benefits-modal/types';

import type { Product } from '../../../types';

interface UseVariantIdProps {
	currentRoute?: 'ops';
	product: Product;
}

export const useVariantId = ({ product, currentRoute }: UseVariantIdProps): VariantId => {
	if (currentRoute === 'ops') {
		return 'standard-rovo-service-agents-ops-team';
	}

	switch (product) {
		case 'jira-customer-service':
			return 'standard-rovo-service-agents-csm-teams';
		case 'jira-service-management':
			return 'standard-rovo-service-agents-service-teams';
		default:
			return 'standard-rovo-service-agents-service-teams';
	}
};
